import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { criptografarMD5 } from "./cryptographyService"

export default {
    obterDepartamentosAsync
}

export const obterDepartamentosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Departamento/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
export const enviarDepartamentoAsync = async (descricao, requisicao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao, requisicao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Departamento`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarDepartamentoAsync = async (id, descricao, requisicao, ativo) => {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, requisicao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Departamento`, requestOptions)
		.then(handleAuthorization)
		.then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}
